import type { UserRead } from "../api/types";

export function collectPermissions(user: UserRead | null | undefined): Set<string> {
  const permissions = new Set<string>();
  for (const role of user?.roles ?? []) {
    for (const permission of role.permissions ?? []) {
      permissions.add(permission.code);
    }
  }
  return permissions;
}

export function hasPermission(
  user: UserRead | null | undefined,
  permission: string,
): boolean {
  return collectPermissions(user).has(permission);
}

export function hasAnyPermission(
  user: UserRead | null | undefined,
  permissions: string[],
): boolean {
  const current = collectPermissions(user);
  return permissions.some((permission) => current.has(permission));
}
